import {combineReducers} from 'redux';
import {PortfolioReducer} from './PortfolioReducer';

const rootReducers = combineReducers({
    PortfolioReducer,
});
export default rootReducers;
